import { FormEvent, useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { authApi } from "../api/auth";

export default function ForgotPasswordPage() {
  const { t } = useTranslation("auth");
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  async function handleSubmit(e: FormEvent) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await authApi.forgotPassword(email);
    } finally {
      setDone(true);
      setSubmitting(false);
    }
  }

  return (
    <div className="auth-shell" style={shell}>
      <div style={card}>
        <h1 style={{ margin: 0, color: "var(--brand-ink)", fontSize: 24 }}>{t("forgot.title")}</h1>

        {done ? (
          <>
            <p style={{ color: "var(--ink-3)", fontSize: 14, lineHeight: 1.6 }}>
              {t("forgot.sent")}
            </p>
            <Link to="/login" style={{ color: "var(--brand-ink)", fontSize: 14 }}>
              {t("forgot.back")}
            </Link>
          </>
        ) : (
          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 16 }}>
            <p style={{ color: "var(--ink-3)", fontSize: 14, margin: 0 }}>
              {t("forgot.intro")}
            </p>
            <label style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: 14 }}>
              <span>{t("login.email")}</span>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={input}
              />
            </label>
            <button type="submit" disabled={submitting} style={btn}>
              {submitting ? t("forgot.submitting") : t("forgot.submit")}
            </button>
            <Link to="/login" style={{ color: "var(--brand-ink)", fontSize: 14, textAlign: "center" }}>
              {t("forgot.back")}
            </Link>
          </form>
        )}
      </div>
    </div>
  );
}

const shell: React.CSSProperties = {
  // Divided by the text-size zoom, which also scales viewport units inside .auth-shell.
  minHeight: "calc(100vh / var(--text-zoom))",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "var(--surface-2)",
  padding: 16,
};
const card: React.CSSProperties = {
  width: "100%",
  maxWidth: 400,
  background: "var(--surface)",
  padding: 32,
  borderRadius: 12,
  boxShadow: "var(--shadow-1)",
  display: "flex",
  flexDirection: "column",
  gap: 16,
};
const input: React.CSSProperties = {
  padding: "10px 12px",
  borderRadius: 6,
  border: "1px solid var(--border-strong)",
  fontSize: 15,
};
const btn: React.CSSProperties = {
  padding: "12px 16px",
  background: "var(--brand-primary-600)",
  color: "var(--on-primary)",
  border: "none",
  borderRadius: 6,
  fontSize: 15,
  fontWeight: 600,
  cursor: "pointer",
};
